import { useCallback, useEffect, useRef, useState } from "react";
import { DatasetReport } from "../@shared/Models/DatasetReport";
import { DataProviderInstance } from "../@shared/services/DataProvider";

export type UseDatasetReportResult = {
    report: DatasetReport | null;
    isLoading: boolean;
    reload: () => void;
}

export const useDatasetReport = (schemaId: string | undefined, isEnabled: boolean): UseDatasetReportResult => {
    const [report, setReport] = useState<DatasetReport | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const loadedSchemaId = useRef<string | null>(null);

    const load = useCallback(async (id: string) => {
        setIsLoading(true);
        try {
            const result = await DataProviderInstance.getReport(id);
            setReport(result.status === 200 ? result.data : null);
        }
        finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        if (!isEnabled || !schemaId || loadedSchemaId.current === schemaId) {
            return;
        }

        loadedSchemaId.current = schemaId;
        load(schemaId);
    }, [schemaId, isEnabled, load]);

    return {
        report,
        isLoading,
        reload: useCallback(() => {
            if (schemaId) {
                load(schemaId);
            }
        }, [schemaId, load])
    };
}
